import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePrivateStatesList } from '~/swr-hooks/filters/usePrivateStatesList';

type PrivateStatesSelectProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateStatesSelect = memo(({ boardId, libraryId, ...props }: PrivateStatesSelectProps) => {
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePrivateStatesList({
    search: debouncedSearchValue,
    boardId,
    libraryId,
  });

  return (
    <StringSelect
      placeholder="Search for state/province"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PrivateStatesSelect.displayName = 'PrivateStatesSelect';
